// Utworzenie pojedynczego elementu
export function el(tagName, props, nest) {
    const element = document.createElement(tagName);
    if (props) {
        for (const name in props) {
            element.setAttribute(name, props[name]);
        }
    }
    if (!nest) {
        return element;
    }
    return nester(element, nest);
}
// Utworzenie zagnieżdżonego elementu
export const nester = (el, nest) => {
    if (nest instanceof Array) {
        for (let i = 0, max = nest.length; i < max; i++) {
            if (typeof nest[i] === "string") {
                const t = document.createTextNode(nest[i]);
                el.appendChild(t);
            }
            else if (nest[i] instanceof Node) {
                el.appendChild(nest[i]);
            }
        }
    }
    else if (typeof nest === 'string') {
        el.textContent = nest;
    }
    else if (nest instanceof Node) {
        el.appendChild(nest);
    }
    return el;
};
